import React from 'react';

import Container from '@src/components/Container';
import VisibleStatusBar from '@src/components/VisibleStatusBar';
import { useBooks } from '@src/database/hooks';
import useAnimatedHeader from '@src/hooks/useAnimatedHeader';

import Card from './Card';
import { List } from './styled';
import { Props } from './types';

const Screen: React.FC<Props> = () => {
  const handleScroll = useAnimatedHeader();
  const books = useBooks();

  return (
    <>
      <VisibleStatusBar />
      <Container>
        <List
          onScroll={handleScroll}
          data={books.data}
          renderItem={({ item }) => <Card item={item} />}
        />
      </Container>
    </>
  );
};

Screen.displayName = 'PrimeLibrary';

export default Screen;
